const DefaultOrgDashboardState = {
    organization_id: ``,
    organization_name: ``,
    org_flag: false,
    organization_status: ``,
    organization_notification: ``,
    organization_message: ``
}

export const OrganizationDashboardState = {data: DefaultOrgDashboardState}